export const types = { CA: "savings", CC: "checking", CE: "specialChecking", CBB: "CBB" };

// Acciones de Echeq centralizadas para comparación
export const EcheqActions = {
    ADMIT: "ADMIT",
    RESCUE: "RESCUE",
    DEPOSIT: "DEPOSIT",
    CUSTODY: "CUSTODY",
    REQUEST_RETURN: "REQUEST-RETURN",
    REPUDIATE: "REPUDIATE",
    REPUDIATE_CESION: "REPUDIATE-CESION",
    ENDORSE: "ENDORSE",
    ENDORSE_MULTIPLE: "ENDORSE-MULTIPLE",
    EMIT: "EMIT",
    ANULATE: "ANULATE-ECHEQ",
    ANULATE_ENDORSE: "ANULATE-ENDORSE",
    ANULATE_CESION: "ANULATE-CESION",
    ADMIT_CESION: "ADMIT-CESION",
    // Agrega aquí otras acciones según el flujo
};
